module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<button type="submit" class="button" id="manage-accounts-button">\n    Create New Account\n</button>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./receipt/templates/manage_accounts_btn.html
// module id = 322
// module chunks = 0